import { useTranslation } from "react-i18next";
import { cn } from "../ui/cn";


interface Tab {
  key: string;
  label: string;
  icon?: string; // Optional icon path
  iconWidth?: number;
  iconHeight?: number;
}

interface ScreenHeaderWithTabsProps {
  title: string;
  tabs: Tab[];
  selectedTab: string;
  onTabChange: (key: string) => void;
  scrollable?: boolean; // Deprecated - tabs now wrap to new line (kept for backwards compatibility)
  showLoadingIndicator?: boolean; // Показувати індикатор завантаження під заголовком
}

export default function ScreenHeaderWithTabs({
  title,
  tabs,
  selectedTab,
  onTabChange,
  scrollable: _scrollable, // Deprecated, not used but kept for backwards compatibility
  showLoadingIndicator = false,
}: ScreenHeaderWithTabsProps) {
  const { t } = useTranslation();
  
  return (
    <div className="w-full max-w-full min-w-0 shrink-0">
      {/* Заголовок */}
      <div className="box-border w-full max-w-full min-w-0 px-[10px] py-[18px] text-center">
        <h1 className="m-0 [font-family:'Rubik_One',sans-serif] text-[24px] leading-[50px] text-white">
          {title}
        </h1>
        {showLoadingIndicator && (
          <div className="flex items-center justify-center gap-md pt-xs text-center [font-family:Lato,sans-serif] text-[12px] text-white-alpha-60">
            <div className="h-3 w-3 rounded-full border-2 border-solid border-white-alpha-30 border-t-white-alpha-80 [animation:spin_0.8s_linear_infinite]" />
            <span>{t("Synchronizing with server...")}</span>
          </div>
        )}
      </div>

      {/* Категорії/Таби */}
      <div className="box-border w-full max-w-full min-w-0 px-2xl">
        <div className="flex w-full flex-wrap gap-md">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => onTabChange(tab.key)}
              className={cn(
                "flex cursor-pointer items-center gap-xs whitespace-nowrap rounded-circle border-none px-lg py-sm [font-family:Lato,sans-serif] text-[14px] leading-[18px] font-normal text-white",
                selectedTab === tab.key
                  ? "bg-[image:var(--gradient-brand-deep)]"
                  : "bg-white-alpha-12",
              )}
            >
              {tab.icon && (
                <img
                  src={tab.icon}
                  alt=""
                  className="shrink-0"
                  style={{
                    width: `${tab.iconWidth ?? 14}px`, // dynamic tab prop
                    height: `${tab.iconHeight ?? 14}px`, // dynamic tab prop
                  }}
                />
              )}
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
